/* @flow */

import { errorHandlerService } from '../services/ServiceRegistry';

/**
 * Save data, string or object, to local storage.
 *
 * @param key
 * @param obj
 * @returns {boolean}
 */
export const saveToLocalStorage = (key, obj) => {
  if (typeof Storage !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(obj));
    return true;
  } else {
    return false;
  }
};

/**
 * Get from local storage saved key.
 *
 * @param key
 * @returns {*}
 */
export const getFromLocalStorage = async key => {
  const item: ?string = localStorage.getItem(key);

  try {
    if (item) {
      return JSON.parse(item);
    }
  } catch (e) {
    errorHandlerService.handleException(e);
    return null;
  }
};

/**
 * Remove item from local storage by key.
 *
 * @param key
 */
export const removeFromLocalStorage = key => {
  if (typeof Storage !== 'undefined') {
    localStorage.removeItem(key);
  }
};
